import { EMPTY_OBJECT } from '~/src/Lib/Utils'

import GENERIC, { initFlowState as initGenericFlowState } from './generic'
import SHARED from './shared'

export const initState = {
  flows: EMPTY_OBJECT,
  showUnsavedHarvestingLeaveDialog: false,
}

export const initialFlowStateMap = {
  GENERIC: initGenericFlowState,
}

export default {
  GENERIC,
  SHARED,
}
